export default __webpack_public_path__ + "aaf28359f3486dc844df8c3f87534b0b.svg";